<div kalDialogContent
     [kalLoading]="loading">

    <div class="courrier" *ngIf="shouldDisplayMailTemplate else letterTemplate">

        <div class="courrier__entete-gauche">
            <p>
                <span class="gup-U-strong">De :&nbsp;</span>
                <span>{{ email?.EmetteurModelEmail }}</span>
            </p>

            <p>
                <span class="gup-U-strong">Objet :&nbsp;</span>
                <span>{{ email?.ObjectModelEmail }}</span>
            </p>

            <p class="gup-U-strong">Contenu : </p>

        </div>

        <div [innerHTML]="email?.CorpsModelEmail | sanitize: 'html'" class="courrier__corps"></div>

        <ng-container *ngIf="attachmentsList | arrayNotEmpty">

            <p class="gup-U-strong">Pièces jointes : </p>

            <div class="courrier__pj">

                <p *ngFor="let attachment of attachmentsList" class="courrier__pj-item">
                    <kal-icon>attach_file</kal-icon>
                    <span>{{ attachment.LibelleLien }}</span>
                </p>

            </div>

        </ng-container>

    </div>

    <ng-template #letterTemplate>

        <div class="courrier">
            <div class="courrier__entete-gauche">
                <!-- Carré pour logo -->
                <div *ngIf="letter?.VoirLogoCE" class="courrier__logo">[Logo CE]</div>

                <!-- Coordonnées CE -->
                <div *ngIf="letter?.VoirCoordonneeCE" class="courrier__exped">[Coordonnées CSE]</div>
            </div>

            <div class="courrier__entete-droite">

                <!-- Coordonnées destinataire -->
                <div class="courrier__destin">[Coordonnées destinataire]</div>

                <!-- Date -->
                <div class="courrier__date">[Date]</div>

            </div>

            <!-- Objet -->
            <div class="courrier__objet">
                <span class="gup-U-strong">Objet :&nbsp;</span>
                <span>{{ letter?.Objet }}</span>
            </div>

            <!-- Introduction -->
            <div *ngIf="letter?.Introduction" class="courrier__intro">
                {{ letter?.Introduction }}
            </div>

            <!-- Corps -->
            <div class="courrier__corps" [innerHTML]="letter?.Corps | sanitize: 'html'"></div>

            <!-- Signature -->
            <div *ngIf="letter?.VoirLogoSignature" class="courrier__sign">
                {{ letter?.SignatureCE }}
            </div>

        </div>

    </ng-template>

</div>

<div kalDialogFooter>

    <div class="gup-C-validationArea-area gup-O-list">

        <div class="gup-O-list__item">
            <kal-button kalTheme="primary"
                        (click)="close()">
                Fermer
            </kal-button>
        </div>

    </div>

</div>
